import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://storage.readdy-site.link/project_files/9eec93be-30e4-4db4-94c1-4bae9d306ad9/b045d82d-ed39-401a-9a2b-72c9f6ef1a25_los-angeles-california-san-bernardino-footage-099667978_iconl.webp?v=0ebec19acaa34f38fddf970f146c69bb"
          alt="Dirty Birdy Hero"
          className="w-full h-full object-cover object-center opacity-50"
          style={{ filter: 'contrast(1.5) saturate(1.4) brightness(1.05)' }}
        />
        {/* Dark Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/90" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center justify-center text-center px-6 pt-2 sm:pt-24 pb-16 animate-fade-in">
        {/* Logo */}
        <div className="w-[400px] h-[160px] -mt-36 sm:mt-0 sm:w-[500px] sm:h-[200px] lg:w-[950px] lg:h-[380px] mb-6 animate-slide-up flex items-center justify-center">
          <img
            src="https://storage.readdy-site.link/project_files/9eec93be-30e4-4db4-94c1-4bae9d306ad9/ba45ea15-108c-4988-b392-fd3e656cd408_Dirty-Birdy-Logo.png?v=9bf4352961de553c930f09c7a662c916"
            alt="Dirty Birdy Logo"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Tagline above */}
        <p className="font-heading font-light text-brand-orange tracking-[0.3em] uppercase text-sm md:text-base mb-3 animate-slide-up">
          
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-10 animate-slide-up">
          <Link
            to="/music"
            className="whitespace-nowrap font-heading font-semibold text-sm tracking-widest uppercase bg-brand-yellow text-black px-10 py-3.5 hover:bg-brand-orange hover:text-white transition-colors duration-200 cursor-pointer"
          >
            Listen Now
          </Link>
          <Link
            to="/store"
            className="whitespace-nowrap font-heading font-semibold text-sm tracking-widest uppercase border border-brand-yellow text-brand-yellow px-10 py-3.5 hover:bg-brand-yellow hover:text-black transition-colors duration-200 cursor-pointer"
          >
            Get Merch
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-pulse-slow">
        <span className="font-heading text-white/30 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-brand-yellow text-xl" />
      </div>
    </section>
  );
}
